import {FC, memo} from 'react'
import {InputStepMode} from '..'

export type AddSingleContactsProps = {
  inputMode: InputStepMode
  setInputMode: (mode: InputStepMode) => void
}
const AddSingleContacts: FC<AddSingleContactsProps> = (props) => {
  const {
    inputMode,
    setInputMode,
  } = props

  return (
    <div className='fv-row mb-10 mt-2'>
      <div className='form-check form-check-custom form-check-solid'>
        <input
          className='form-check-input mb-6'
          type='radio'
          value=''
          id='flexRadioChecked5'
          checked={inputMode === InputStepMode.AddSingleContact}
          onChange={() => setInputMode(InputStepMode.AddSingleContact)}
        />
        <label
          className='form-check-label align-items-start flex-column d-flex ms-3'
          htmlFor='flexRadioChecked5'
        >
          <span className='card-label fw-bolder fs-5'>Add Single Contact</span>
          <span className=' fs-7'>
            <div className='text-muted'>
              Enter detail of single contact
            </div>
          </span>
        </label>
      </div>
    </div>
  )
}

export default memo(AddSingleContacts)
